import React from "react";

const Line = ({className =""})=>{

    return (

        <>
        
        <div className={`h-[90px] w-[30px] flex items-center justify-center bg-[#FFFFF] ${className}`}>

               <div className="relative h-full w-[1px] bg-gray-500" >

                    <div className="absolute top-[47px] left-[15px] -translate-x-[21px] -translate-y-[5px] w-3 h-3 bg-red-700 rotate-45">


                    </div>

               </div>

        </div>
        </>
    );
};

export default Line;